// Who is editing the product, for the product dialog's tab rules.
//
// The dialog is the admin store's, and the merchant portal opens the very same
// one: a merchant (a member of an organization who is not a platform admin)
// gets a simpler dialog. Their product is a one-time purchase priced in one
// currency (vendor-pricing replaces the framework's Pricing tab), and what only
// Aldoo decides — the free metadata, which rows the store page shows — is not
// theirs to see. Declared as a `visibilityContext` by the extensions whose
// rules ask it (deduplicated by identity, so it runs once).
import { useVendorAccess } from "../../../AdminShared/VendorContext"

// the framework's own tabs a merchant does not see (aldoo-ra builtin-tabs.js `hiddenBuiltinTabs`):
// the free metadata, and a bundle's configuration — a merchant's product is a one-time purchase
const VENDOR_HIDDEN_BUILTIN_TABS = ["metadata", "bundle"]

/**
 * `vendorEditor`: the dialog is a merchant's — known once the access is
 * resolved, so while it loads (and for a platform admin) the admin's tabs stand.
 */
export function useVendorVisibilityContext() {
  const { isAdmin, loading } = useVendorAccess()
  const vendorEditor = !loading && !isAdmin
  return { vendorEditor, hiddenBuiltinTabs: vendorEditor ? VENDOR_HIDDEN_BUILTIN_TABS : [] }
}

/** A tab rule that holds for a platform admin only (`and` is the tab's own rule, asked on top). */
export const adminOnly = (and) => (context) => {
  if (context?.vendorEditor) return false
  return and ? and(context) !== false : true
}
